import { FC, PropsWithChildren } from "react";

import { DraggableWrapper, DroppableRideWrapper } from "@ryde/controls";
import { useRidesNavigation } from "@ryde/redux";
import {
  DragTypeEnum,
  DropTypeEnum,
  generateDragIdCardBoardItem,
  generateDropIdCardBoardItem,
  IRideTableDto,
} from "@ryde/shared";

interface ICardBoardDroppableWrapperProps extends PropsWithChildren {
  rideDto: IRideTableDto;
}

export const CardBoardDroppableWrapper: FC<ICardBoardDroppableWrapperProps> = ({
  rideDto,
  children,
}) => {
  const { isRidesEditOrAddRoute } = useRidesNavigation();

  const draggableId = generateDragIdCardBoardItem(rideDto.id);
  return (
    <DroppableRideWrapper
      id={generateDropIdCardBoardItem(rideDto.id)}
      disabled={isRidesEditOrAddRoute}
      dropData={{
        accepts: [DragTypeEnum.KANBAN_PASSENGER, DragTypeEnum.CARD_BOARD_RIDE],
        typeDrop: DropTypeEnum.CARD_BOARD_RIDE_DROP,
        rideDrop: rideDto,
      }}
    >
      <DraggableWrapper
        id={draggableId}
        disabled={isRidesEditOrAddRoute}
        dragData={{ type: DragTypeEnum.CARD_BOARD_RIDE, payload: { rideDto } }}
        isListeners={false}
      >
        {children}
      </DraggableWrapper>
    </DroppableRideWrapper>
  );
};
